// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QueryFilters {
  --qf-control-height: 3rem;
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  flex-wrap: nowrap;
}

#PageFilters .QueryFilters .QueryFilters-Control,
#PageFilters .QueryFilters .QueryFilters-Input {
  display: flex;
  gap: 0.5rem;
  max-height: var(--qf-control-height);
}
#PageFilters .QueryFilters .QueryFilters-Input {
  min-width: 75px;
  max-width: 140px;
}
#PageFilters .QueryFilters .InputWithIcon,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input,
#PageFilters .QueryFilters .Dropdown,
#PageFilters .QueryFilters .btn,
#PageFilters .QueryFilters .ant-picker {
  height: var(--qf-control-height);
  box-shadow: 4px 5px 16px 0px rgba(0, 0, 0, 0.35);
}
#PageFilters .QueryFilters .InputWithIcon,
#PageFilters .QueryFilters .InputWithIcon > .input-group-text,
#PageFilters .QueryFilters .InputWithIcon > .input-group-text > .btn,
#PageFilters .QueryFilters input,
#PageFilters .QueryFilters .ant-picker {
  background-color: transparent;
  border-color: var(--bs-secondary-subtle);
  color: var(--bs-secondary-subtle) !important;
}
#PageFilters .QueryFilters .InputWithIcon.Dropdown-Input.is-selected::placeholder,
#PageFilters .QueryFilters .InputWithIcon > .input-group-text.Dropdown-Input.is-selected::placeholder,
#PageFilters .QueryFilters .InputWithIcon > .input-group-text > .btn.Dropdown-Input.is-selected::placeholder,
#PageFilters .QueryFilters input.Dropdown-Input.is-selected::placeholder,
#PageFilters .QueryFilters .ant-picker.Dropdown-Input.is-selected::placeholder {
  color: var(--bs-secondary);
}
#PageFilters .QueryFilters .InputWithIcon::placeholder,
#PageFilters .QueryFilters .InputWithIcon > .input-group-text::placeholder,
#PageFilters .QueryFilters .InputWithIcon > .input-group-text > .btn::placeholder,
#PageFilters .QueryFilters input::placeholder,
#PageFilters .QueryFilters .ant-picker::placeholder {
  color: var(--bs-secondary-subtle) !important;
}
#PageFilters .QueryFilters .form-check-input {
  --switch-size: 1.75rem;
}
#PageFilters .QueryFilters .form-check-input:checked {
  background-color: var(--bs-success);
}
#PageFilters .QueryFilters .ant-picker {
  height: var(--qf-control-height);
}
#PageFilters .QueryFilters .fa,
#PageFilters .QueryFilters .fa-regular {
  color: var(--bs-secondary-subtle);
}
#PageFilters .QueryFilters .ActionsDropdown .fa-ellipsis-v {
  font-size: 2rem;
}
#PageFilters .QueryFilters .Dropdown:hover, #PageFilters .QueryFilters .Dropdown:hover i.fa-calendar, #PageFilters .QueryFilters .Dropdown:hover > .input-group-text > .btn > i, #PageFilters .QueryFilters .Dropdown:hover::placeholder,
#PageFilters .QueryFilters .Dropdown:hover .Dropdown-Input::placeholder, #PageFilters .QueryFilters .Dropdown.ant-picker-focused, #PageFilters .QueryFilters .Dropdown.ant-picker-focused i.fa-calendar, #PageFilters .QueryFilters .Dropdown.ant-picker-focused > .input-group-text > .btn > i, #PageFilters .QueryFilters .Dropdown.ant-picker-focused::placeholder,
#PageFilters .QueryFilters .Dropdown.ant-picker-focused .Dropdown-Input::placeholder, #PageFilters .QueryFilters .Dropdown:focus, #PageFilters .QueryFilters .Dropdown:focus i.fa-calendar, #PageFilters .QueryFilters .Dropdown:focus > .input-group-text > .btn > i, #PageFilters .QueryFilters .Dropdown:focus::placeholder,
#PageFilters .QueryFilters .Dropdown:focus .Dropdown-Input::placeholder, #PageFilters .QueryFilters .Dropdown:active, #PageFilters .QueryFilters .Dropdown:active i.fa-calendar, #PageFilters .QueryFilters .Dropdown:active > .input-group-text > .btn > i, #PageFilters .QueryFilters .Dropdown:active::placeholder,
#PageFilters .QueryFilters .Dropdown:active .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .InputWithIcon:hover,
#PageFilters .QueryFilters .InputWithIcon:hover i.fa-calendar,
#PageFilters .QueryFilters .InputWithIcon:hover > .input-group-text > .btn > i,
#PageFilters .QueryFilters .InputWithIcon:hover::placeholder,
#PageFilters .QueryFilters .InputWithIcon:hover .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .InputWithIcon.ant-picker-focused,
#PageFilters .QueryFilters .InputWithIcon.ant-picker-focused i.fa-calendar,
#PageFilters .QueryFilters .InputWithIcon.ant-picker-focused > .input-group-text > .btn > i,
#PageFilters .QueryFilters .InputWithIcon.ant-picker-focused::placeholder,
#PageFilters .QueryFilters .InputWithIcon.ant-picker-focused .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .InputWithIcon:focus,
#PageFilters .QueryFilters .InputWithIcon:focus i.fa-calendar,
#PageFilters .QueryFilters .InputWithIcon:focus > .input-group-text > .btn > i,
#PageFilters .QueryFilters .InputWithIcon:focus::placeholder,
#PageFilters .QueryFilters .InputWithIcon:focus .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .InputWithIcon:active,
#PageFilters .QueryFilters .InputWithIcon:active i.fa-calendar,
#PageFilters .QueryFilters .InputWithIcon:active > .input-group-text > .btn > i,
#PageFilters .QueryFilters .InputWithIcon:active::placeholder,
#PageFilters .QueryFilters .InputWithIcon:active .Dropdown-Input::placeholder,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:hover,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:hover i.fa-calendar,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:hover > .input-group-text > .btn > i,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:hover::placeholder,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:hover .Dropdown-Input::placeholder,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input.ant-picker-focused,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input.ant-picker-focused i.fa-calendar,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input.ant-picker-focused > .input-group-text > .btn > i,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input.ant-picker-focused::placeholder,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input.ant-picker-focused .Dropdown-Input::placeholder,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:focus,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:focus i.fa-calendar,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:focus > .input-group-text > .btn > i,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:focus::placeholder,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:focus .Dropdown-Input::placeholder,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:active,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:active i.fa-calendar,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:active > .input-group-text > .btn > i,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:active::placeholder,
#PageFilters .QueryFilters *:not(.InputWithIcon) > .Input:active .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .Dropdown:hover,
#PageFilters .QueryFilters .Dropdown:hover i.fa-calendar,
#PageFilters .QueryFilters .Dropdown:hover > .input-group-text > .btn > i,
#PageFilters .QueryFilters .Dropdown:hover::placeholder,
#PageFilters .QueryFilters .Dropdown:hover .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .Dropdown.ant-picker-focused,
#PageFilters .QueryFilters .Dropdown.ant-picker-focused i.fa-calendar,
#PageFilters .QueryFilters .Dropdown.ant-picker-focused > .input-group-text > .btn > i,
#PageFilters .QueryFilters .Dropdown.ant-picker-focused::placeholder,
#PageFilters .QueryFilters .Dropdown.ant-picker-focused .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .Dropdown:focus,
#PageFilters .QueryFilters .Dropdown:focus i.fa-calendar,
#PageFilters .QueryFilters .Dropdown:focus > .input-group-text > .btn > i,
#PageFilters .QueryFilters .Dropdown:focus::placeholder,
#PageFilters .QueryFilters .Dropdown:focus .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .Dropdown:active,
#PageFilters .QueryFilters .Dropdown:active i.fa-calendar,
#PageFilters .QueryFilters .Dropdown:active > .input-group-text > .btn > i,
#PageFilters .QueryFilters .Dropdown:active::placeholder,
#PageFilters .QueryFilters .Dropdown:active .Dropdown-Input::placeholder,
#PageFilters .QueryFilters input:hover,
#PageFilters .QueryFilters input:hover i.fa-calendar,
#PageFilters .QueryFilters input:hover > .input-group-text > .btn > i,
#PageFilters .QueryFilters input:hover::placeholder,
#PageFilters .QueryFilters input:hover .Dropdown-Input::placeholder,
#PageFilters .QueryFilters input.ant-picker-focused,
#PageFilters .QueryFilters input.ant-picker-focused i.fa-calendar,
#PageFilters .QueryFilters input.ant-picker-focused > .input-group-text > .btn > i,
#PageFilters .QueryFilters input.ant-picker-focused::placeholder,
#PageFilters .QueryFilters input.ant-picker-focused .Dropdown-Input::placeholder,
#PageFilters .QueryFilters input:focus,
#PageFilters .QueryFilters input:focus i.fa-calendar,
#PageFilters .QueryFilters input:focus > .input-group-text > .btn > i,
#PageFilters .QueryFilters input:focus::placeholder,
#PageFilters .QueryFilters input:focus .Dropdown-Input::placeholder,
#PageFilters .QueryFilters input:active,
#PageFilters .QueryFilters input:active i.fa-calendar,
#PageFilters .QueryFilters input:active > .input-group-text > .btn > i,
#PageFilters .QueryFilters input:active::placeholder,
#PageFilters .QueryFilters input:active .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .ant-picker:hover,
#PageFilters .QueryFilters .ant-picker:hover i.fa-calendar,
#PageFilters .QueryFilters .ant-picker:hover > .input-group-text > .btn > i,
#PageFilters .QueryFilters .ant-picker:hover::placeholder,
#PageFilters .QueryFilters .ant-picker:hover .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .ant-picker.ant-picker-focused,
#PageFilters .QueryFilters .ant-picker.ant-picker-focused i.fa-calendar,
#PageFilters .QueryFilters .ant-picker.ant-picker-focused > .input-group-text > .btn > i,
#PageFilters .QueryFilters .ant-picker.ant-picker-focused::placeholder,
#PageFilters .QueryFilters .ant-picker.ant-picker-focused .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .ant-picker:focus,
#PageFilters .QueryFilters .ant-picker:focus i.fa-calendar,
#PageFilters .QueryFilters .ant-picker:focus > .input-group-text > .btn > i,
#PageFilters .QueryFilters .ant-picker:focus::placeholder,
#PageFilters .QueryFilters .ant-picker:focus .Dropdown-Input::placeholder,
#PageFilters .QueryFilters .ant-picker:active,
#PageFilters .QueryFilters .ant-picker:active i.fa-calendar,
#PageFilters .QueryFilters .ant-picker:active > .input-group-text > .btn > i,
#PageFilters .QueryFilters .ant-picker:active::placeholder,
#PageFilters .QueryFilters .ant-picker:active .Dropdown-Input::placeholder {
  border-color: var(--bs-secondary) !important;
  color: var(--bs-secondary) !important;
}
#PageFilters .QueryFilters .ant-picker.border-secondary .fa-calendar,
#PageFilters .QueryFilters .ant-picker.border-secondary input,
#PageFilters .QueryFilters .ant-picker.border-secondary input::placeholder {
  color: var(--bs-secondary) !important;
}
#PageFilters .QueryFilters button:focus, #PageFilters .QueryFilters button:hover, #PageFilters .QueryFilters button.btn-outline-secondary-subtle:focus, #PageFilters .QueryFilters button.btn-outline-secondary-subtle:hover,
#PageFilters .QueryFilters .btn:focus,
#PageFilters .QueryFilters .btn:hover,
#PageFilters .QueryFilters .btn.btn-outline-secondary-subtle:focus,
#PageFilters .QueryFilters .btn.btn-outline-secondary-subtle:hover,
#PageFilters .QueryFilters .FormButton:focus,
#PageFilters .QueryFilters .FormButton:hover,
#PageFilters .QueryFilters .FormButton.btn-outline-secondary-subtle:focus,
#PageFilters .QueryFilters .FormButton.btn-outline-secondary-subtle:hover {
  background-color: transparent;
  color: var(--bs-secondary);
  border-color: var(--bs-secondary);
}`, "",{"version":3,"sources":["webpack://./src/components/QueryFilters/styles.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;EAEA,aAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;AAFF;;AAOI;;EAEE,aAAA;EACA,WAAA;EACA,oCAAA;AAJN;AAMI;EACE,eAAA;EACA,gBAAA;AAJN;AAMI;;;;;EAKE,gCAAA;EACA,gDAAA;AAJN;AAMI;;;;;EAKE,6BAAA;EACA,wCAAA;EACA,4CAAA;AAJN;AAKM;;;;;EACE,0BAAA;AACR;AACM;;;;;EACE,4CAAA;AAKR;AAFI;EACE,sBAAA;AAIN;AAHM;EACE,mCAAA;AAKR;AAFI;EACE,gCAAA;AAIN;AAFI;;EAEE,iCAAA;AAIN;AAFI;EACE,eAAA;AAIN;AAQQ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAKE,4CAAA;EACA,qCAAA;AA8FV;AAxFQ;;;EAGE,qCAAA;AA0FV;AAjFQ;;;;;;;;;EAEE,6BAAA;EACA,0BAAA;EACA,iCAAA;AA0FV","sourcesContent":["$control-height: 3rem;\n\n.QueryFilters {\n  --qf-control-height: #{$control-height};\n\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  flex-wrap: nowrap;\n}\n\n#PageFilters {\n  .QueryFilters {\n    .QueryFilters-Control,\n    .QueryFilters-Input {\n      display: flex;\n      gap: 0.5rem;\n      max-height: var(--qf-control-height);\n    }\n    .QueryFilters-Input {\n      min-width: 75px;\n      max-width: 140px;\n    }\n    .InputWithIcon,\n    *:not(.InputWithIcon) > .Input,\n    .Dropdown,\n    .btn,\n    .ant-picker {\n      height: var(--qf-control-height);\n      box-shadow: 4px 5px 16px 0px rgba(0, 0, 0, 0.35);\n    }\n    .InputWithIcon,\n    .InputWithIcon > .input-group-text,\n    .InputWithIcon > .input-group-text > .btn,\n    input,\n    .ant-picker {\n      background-color: transparent;\n      border-color: var(--bs-secondary-subtle);\n      color: var(--bs-secondary-subtle) !important;\n      &.Dropdown-Input.is-selected::placeholder {\n        color: var(--bs-secondary);\n      }\n      &::placeholder {\n        color: var(--bs-secondary-subtle) !important;\n      }\n    }\n    .form-check-input {\n      --switch-size: 1.75rem;\n      &:checked {\n        background-color: var(--bs-success);\n      }\n    }\n    .ant-picker {\n      height: var(--qf-control-height);\n    }\n    .fa,\n    .fa-regular {\n      color: var(--bs-secondary-subtle);\n    }\n    .ActionsDropdown .fa-ellipsis-v {\n      font-size: 2rem;\n    }\n    .Dropdown,\n    .InputWithIcon,\n    *:not(.InputWithIcon) > .Input,\n    .Dropdown,\n    input,\n    .ant-picker {\n      &:hover,\n      &.ant-picker-focused,\n      &:focus,\n      &:active {\n        &,\n        & i.fa-calendar,\n        & > .input-group-text > .btn > i,\n        &::placeholder,\n        .Dropdown-Input::placeholder {\n          border-color: var(--bs-secondary) !important;\n          color: var(--bs-secondary) !important;\n        }\n      }\n    }\n    .ant-picker {\n      &.border-secondary {\n        .fa-calendar,\n        input,\n        input::placeholder {\n          color: var(--bs-secondary) !important;\n        }\n      }\n    }\n    button,\n    .btn,\n    .FormButton {\n      &,\n      &.btn-outline-secondary-subtle {\n        &:focus,\n        &:hover {\n          background-color: transparent;\n          color: var(--bs-secondary);\n          border-color: var(--bs-secondary);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
